import { thinkScrollbar } from "@/utils/thinkScrollbar";
// import { background, transition } from "@chakra-ui/react";

const breakpoints = [450, 770, 1024, 1232, 1440];

const mq = breakpoints.map((bp) => `@media (min-width: ${bp}px)`);

const customSelectStyle = ({ ...props }) => {
  const {
    container,
    input,
    inputContainer,
    control,
    placeholder,
    downChevron,
    dropdownIndicator,
    indicatorSeparator,
    indicatorsContainer,
    singleValue,
    valueContainer,
    menu,
    menuList,
    option,
    // noOptionsMessage,
  } = props;
  return {
    container: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      [mq[1]]: {},
      align: "flex-start",
      ...container,
    }),
    input: (provided) => ({
      ...provided,
      maxHeight: "40px",
      ...input,
    }),
    inputContainer: (provided) => ({
      ...provided,
      maxHeight: "40px",
      ...inputContainer,
    }),
    control: (provided, { isFocused }) => ({
      ...provided,
      boxShadow: isFocused ? "none" : "none",
      borderColor: isFocused ? "mainBlue" : "grey",
      maxHeight: "40px",
      maxWidth: "245px",
      borderRadius: "3px",
      bg: "menuGray",

      "&:hover": {
        boxShadow: "none",
        borderColor: "mainBlue",
        outline: "none",
        outlineOffset: "0",
      },

      "&:focus-within": {
        boxShadow: "none",
        outline: "none",
        outlineOffset: "0",
      },
      ...control,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "grey",
      ...placeholder,
    }),

    downChevron: (provided) => ({
      ...provided,
      ...downChevron,
    }),
    dropdownIndicator: (provided, state) => {
      return {
        ...provided,
        display: state.selectProps.dropdownIndicatorHide ? "none" : "flex",
        background: "none",
        color: "mainBlue",
        paddingInline: "7.5px",
        transition: "all .2s ease",
        transform: state.selectProps.menuIsOpen
          ? "rotate(180deg)"
          : "rotate(0)",
        maxHeight: "38px",
        ...dropdownIndicator,
      };
    },
    indicatorsContainer: (provided) => ({
      ...provided,
      ...indicatorsContainer,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
      indicatorSeparator,
    }),
    singleValue: (provided) => ({
      ...provided,
      maxHeight: "40px",
      ...singleValue,
    }),
    valueContainer: (provided) => ({
      ...provided,
      cursor: "pointer",
      padding: "8px 20px",
      color: "mainBlue",
      fontSize: "14px",
      maxHeight: "38px",
      sx: thinkScrollbar,
      ...valueContainer,
    }),
    menu: (provided) => ({
      ...provided,
      boxShadow: "none",
      marginTop: "4px",
      zIndex: "10",
      maxWidth: "245px",
      ...menu,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "0",
      maxHeight: "250px",
      borderRadius: "3.75px",
      boxShadow: "5px 10px 15px rgba(0,0,0,0.1)",
      ...menuList,
    }),
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        padding: "8px 16px",
        color: "mainBlue",
        transition: "all 0.3s ease-in-out",
        bg: isSelected ? "mainBlue" : "menuGray",
        fontSize: "14px",
        _hover: {
          background: "grey",
          color: "menuGray",
        },
        ...option,
      };
    },
  };
};

export default customSelectStyle;
